import { Action, Reducer } from 'redux';

import { BaseParams } from '@common/typescript/objects/BaseParams';

export interface ItemState<T> {
	isLoading: boolean;
	item: T;
	type: string;
	params: BaseParams;
	isEmpty?: boolean;
}

export enum TypeKeys {
	UPDATEITEM = 'UPDATEITEM',
	SETITEM = 'SETITEM',
	REQUESTITEM = 'REQUESTITEM',
}

interface SetItemAction<T> {
	item: T;
	type: TypeKeys.SETITEM;
	storageName: string | null;
	params: any;
	objectType: string;
}

interface UpdateItemAction<T> {
	item: Partial<T>;
	type: TypeKeys.UPDATEITEM;
	storageName: string | null;
}

interface RequestItemAction {
	type: TypeKeys.REQUESTITEM;
	storageName: string | null;
	params: any;
	objectType: string;
}

export type KnownPageAction<T> = SetItemAction<T> | RequestItemAction | UpdateItemAction<T>;

export function getReducer<T>(storageName: string): Reducer<ItemState<T>> {
	return (s: ItemState<T> | undefined, incomingAction: Action) => {
		const state = s as ItemState<T>;
		const action = incomingAction as KnownPageAction<T>;
		if (!action.storageName || action.storageName === storageName) {
			switch (action.type) {
				case TypeKeys.SETITEM:
					return {
						isLoading: false,
						item: action.item,
						params: action.params || {},
						type: action.objectType,
					};
				case TypeKeys.UPDATEITEM:
					return {
						...state,
						item: { ...state.item, ...action.item },
					};
				case TypeKeys.REQUESTITEM:
					return {
						...state, isLoading: true, params: action.params, type: action.objectType,
					};
				default:
					return state || {
						isLoading: false,
						params: {},
						item: [],
						isEmpty: true,
					};
			}
		}

		return state;
	};
}
